import { useParams } from "react-router-dom";
import QuizForm from "./QuizForm";

// Editar questionário: o formulário compartilhado com o novo
export default function EditQuiz() {
  const { id } = useParams();
  return <QuizForm key={id} quizId={id} />;
}
